import { render, staticRenderFns } from "./MyZs3.vue?vue&type=template&id=1f8d604e&scoped=true&"
import script from "./MyZs3.vue?vue&type=script&lang=js&"
export * from "./MyZs3.vue?vue&type=script&lang=js&"
import style0 from "./MyZs3.vue?vue&type=style&index=0&id=1f8d604e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8d604e",
  null
  
)

export default component.exports